"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { d: "M4.4868 8.8402 12 14.2664l7.5132-5.4262L12 4.3323l-7.5132 4.508ZM20 10.9557l-7.4145 5.3549a.9998.9998 0 0 1-1.171 0L4 10.9557v9.0442h16v-9.0442ZM2.4855 7.7087l9-5.4a1 1 0 0 1 1.029 0l9 5.4A1 1 0 0 1 22 8.566V21c0 .5523-.4477 1-1 1H3c-.5523 0-1-.4477-1-1V8.5661a1 1 0 0 1 .4855-.8575Z" })), 'ReadIcon');
